import { isIE11 } from './isIE11';

export default function getScrollX() {
  return isIE11 ? window.pageXOffset : window.scrollX;
}
